import React from 'react';
import { useNavigate, Link, useSearchParams } from 'react-router-dom';
import { MonoLabel } from '../components/Editorial';
import { sanitizeNext } from '../lib/publicProfile';

const ROLES = [
  {
    key: 'player',
    title: 'Athlete',
    blurb: 'Build a verified profile, get on the recruiting board, get found by coaches.',
    cta: 'Sign up as an athlete',
    path: '/register/athlete',
  },
  {
    key: 'coach',
    title: 'Coach',
    blurb: 'Search verified athletes, build lists, and message prospects.',
    cta: 'Sign up as a coach',
    path: '/register/coach',
  },
  {
    key: 'guardian',
    title: 'Parent or Guardian',
    blurb: 'Manage your athlete\'s profile from your own account. Athletes under 13 sign up this way.',
    cta: 'Sign up as a parent',
    path: '/register/parent',
  },
];

export default function SignupRolePicker() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  // A coach who signs up instead of signing in should still land on the
  // athlete whose public profile sent them here.
  //
  // `next` has no provenance once it has crossed a page boundary — it is
  // re-read from this page's own URL, which anyone can compose, so it is
  // re-validated here rather than trusted because LoginPage already checked
  // it. Every hop that re-forwards `next` must sanitize for itself, or a
  // hostile value could ride along looking legitimate.
  const safeNext = sanitizeNext(searchParams.get('next'));
  const nextQs = safeNext ? `?next=${encodeURIComponent(safeNext)}` : '';

  return (
    <div className="ed-auth">
      <div className="ed-auth__hero">
        <div>
          <MonoLabel onDark>JOIN PROZPECTS</MonoLabel>
          <h1 className="ed-auth__hero-headline" style={{ marginTop: 16 }}>
            Pick the<br /><em>account type.</em>
          </h1>
        </div>
        <p className="ed-auth__hero-quote">
          "Coaches search verified athletes first. Build a profile, get verified at a camp, get found."
        </p>
      </div>

      <div className="ed-auth__form-wrap">
        <div className="ed-auth__form">
          <div className="auth-logo" style={{ marginBottom: 24 }}>
            <img src="/logo-wordmark.png" alt="ProZpects" style={{ maxHeight: 36 }} />
          </div>
          <MonoLabel>NEW ACCOUNT</MonoLabel>
          <h2 style={{
            fontFamily: 'var(--ed-font-serif)',
            fontSize: 36,
            fontWeight: 400,
            letterSpacing: '-0.015em',
            margin: '8px 0 24px',
          }}>
            Sign up.
          </h2>

          <div className="role-picker-grid">
            {ROLES.map((r) => (
              <button
                key={r.key}
                type="button"
                className="role-picker-card"
                onClick={() => navigate(`${r.path}${nextQs}`)}
              >
                <div className="role-picker-card__title">{r.title}</div>
                <div className="role-picker-card__blurb">{r.blurb}</div>
                <div className="role-picker-card__cta">{r.cta} →</div>
              </button>
            ))}
          </div>

          <div className="auth-footer" style={{ marginTop: 32 }}>
            Already have an account? <Link to="/login">Log in</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
